import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ScrollLock from 'react-scrolllock';

/* Constants */
import {
  HB_BOUNCING_INDICATOR_VIEW_TYPE_CONFIGS,
  HB_BOUNCING_INDICATOR_VIEW_TYPES,
} from './hbBouncingIndicatorViewTypes';

import s from './hb-bouncing-indicator.scss';

class HbBouncingIndicator extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    viewType: PropTypes.string,
  }

  render() {
    const {
      className,
      viewType,
    } = this.props;

    const rootClassName = cx(
      s.root,
      className,
      HB_BOUNCING_INDICATOR_VIEW_TYPE_CONFIGS[viewType] &&
        s[HB_BOUNCING_INDICATOR_VIEW_TYPE_CONFIGS[viewType].className],
    );

    return (
      <div className={rootClassName}>
        {
          viewType === HB_BOUNCING_INDICATOR_VIEW_TYPES.FULL_SCREEN &&
          <ScrollLock/>
        }

        <div className={s.overlay}/>
        <div className={cx(s.ball, s.firstBall, 'hb-bouncing-indicator__ball')}/>
        <div className={cx(s.ball, s.secondBall, 'hb-bouncing-indicator__ball')}/>
        <div className={cx(s.ball, s.thirdBall, 'hb-bouncing-indicator__ball')}/>
      </div>
    )
  }
}

export default HbBouncingIndicator;
